(function () {
  function qs(root, sel) {
    return (root || document).querySelector(sel);
  }
  function qsa(root, sel) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function formatMoney(cents) {
    var fmt = window.themeMoneyFormat || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      try {
        return Shopify.formatMoney(cents, fmt);
      } catch (e) {}
    }
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }

  function initProduct(root) {
    var jsonEl = qs(document, '[data-bff-product-json]');
    if (!root || !jsonEl) return;
    var product;
    try {
      product = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }

    var variantInput = qs(root, '[data-bff-variant-id]');
    var priceEl = qs(root, '[data-bff-price-money]');
    var compareEl = qs(root, '[data-bff-compare-money]');
    var mainImg = qs(root, '[data-bff-main-image]');
    var optionSelects = qsa(root, '[data-bff-option-select]');

    /* ---- calculator config from Liquid JSON ---- */
    var sqftPer = 0;
    var pricePerSqftCents = 0;

    var cfgEl = qs(root, '[data-bff-calculator-config]');
    if (cfgEl) {
      try {
        var cfg = JSON.parse(cfgEl.textContent.trim());
        if (cfg.sqftPerCarton != null && Number(cfg.sqftPerCarton) > 0) {
          sqftPer = Number(cfg.sqftPerCarton);
        }
        if (cfg.pricePerSqftCents != null && Number(cfg.pricePerSqftCents) > 0) {
          pricePerSqftCents = Math.round(Number(cfg.pricePerSqftCents));
        }
      } catch (e) {}
    }

    /* fallback from data attribute */
    if (!sqftPer) {
      sqftPer = parseFloat(root.getAttribute('data-sqft-per-carton')) || 0;
    }
    if (!pricePerSqftCents) {
      pricePerSqftCents = Math.round(parseFloat(root.getAttribute('data-bff-price-per-sqft-cents')) || 0);
    }

    var sqftInput    = qs(root, '[data-bff-sqft-input]');
    var overageChk   = qs(root, '[data-bff-overage]');
    var cartonsOut   = qs(root, '[data-bff-cartons]');
    var cartonQtyDisplay = qs(root, '[data-bff-carton-qty-display]');
    var recommendWrap = qs(root, '[data-bff-recommend-wrap]');
    var recommendCartons = qs(root, '[data-bff-recommend-cartons]');
    var recommendSqft = qs(root, '[data-bff-recommend-sqft]');
    var totalSqftOut = qs(root, '[data-bff-total-sqft]');
    var qtyHidden    = qs(root, '[data-bff-qty-hidden]');
    var propSqft     = qs(root, '[data-bff-prop-sqft]');
    var propOver     = qs(root, '[data-bff-prop-overage]');
    var propCartons  = qs(root, '[data-bff-prop-cartons]');
    var propCartonsCount = qs(root, '[data-bff-prop-cartons-count]');
    var FREIGHT_CARTON_MIN = 10;
    var subWrap      = qs(root, '[data-bff-subtotal-wrap]');
    var subMoney     = qs(root, '[data-bff-subtotal-money]');
    var subSqftLabel = qs(root, '[data-bff-subtotal-sqft]');
    var subRateLabel = qs(root, '[data-bff-subtotal-rate]');
    var shippingQuoteNote = qs(root, '[data-bff-shipping-quote]');
    var shippingFreeNote = qs(root, '[data-bff-shipping-free]');
    var shippingUnder500Note = qs(root, '[data-bff-shipping-under500]');
    var shippingResidentialNote = qs(root, '[data-bff-shipping-residential]');
    var fulfillmentInputs = qsa(root, '[data-bff-fulfillment-input]');
    var propFulfillment = qs(root, '[data-bff-prop-fulfillment]');
    var propAddressType = qs(root, '[data-bff-prop-address-type]');
    var callQuoteCta = qs(root, '[data-bff-call-quote-cta]');
    var contactQuoteCta = qs(root, '[data-bff-contact-quote-cta]');
    var quotePhoneHint = qs(root, '[data-bff-quote-phone-hint]');
    var SHIPPING_THRESHOLD_SQFT = 500;

    function getSelectedFulfillment() {
      var selected = fulfillmentInputs.find(function (input) { return input.checked; });
      return selected ? selected.value : 'pickup';
    }

    function getTotalSqft() {
      return parseInt(totalSqftOut ? totalSqftOut.textContent : '0', 10) || 0;
    }

    function canOrderOnline() {
      var v = findVariant();
      if (!v || !v.available) return false;
      var totalSqft = getTotalSqft();
      var fulfillment = getSelectedFulfillment();
      /* Straight to cart only for commercial ship at 500+ sq ft.
         Residential, pickup, or under 500 → Contact us for shipping help. */
      if (fulfillment !== 'ship-commercial') return false;
      if (sqftInput && totalSqft < SHIPPING_THRESHOLD_SQFT) return false;
      return true;
    }

    function syncFulfillmentProperties() {
      var fulfillment = getSelectedFulfillment();
      if (propFulfillment) {
        if (fulfillment === 'pickup') propFulfillment.value = 'Pickup';
        else if (fulfillment === 'ship-commercial') propFulfillment.value = 'Ship — commercial';
        else propFulfillment.value = 'Ship — residential';
      }
      if (propAddressType) {
        if (fulfillment === 'ship-commercial') propAddressType.value = 'Commercial';
        else if (fulfillment === 'ship-residential') propAddressType.value = 'Residential';
        else propAddressType.value = '';
      }
    }

    function updateOrderCta() {
      var addBtn = qs(root, '[data-bff-add]');
      var allowOrder = canOrderOnline();
      var v = findVariant();
      if (addBtn) {
        addBtn.hidden = !allowOrder;
        if (v) {
          addBtn.disabled = !v.available || !allowOrder;
          var def = addBtn.getAttribute('data-label-available') || 'Order';
          var sold = addBtn.getAttribute('data-label-sold') || 'Sold out';
          addBtn.textContent = v.available ? def : sold;
        }
      }
      if (callQuoteCta) callQuoteCta.hidden = allowOrder;
      if (contactQuoteCta) contactQuoteCta.hidden = allowOrder;
      if (quotePhoneHint) quotePhoneHint.hidden = allowOrder;
      syncFulfillmentProperties();
    }

    function variantOptionValues(v) {
      if (v.options && Array.isArray(v.options)) return v.options;
      var out = [];
      if (v.option1 != null && v.option1 !== '') out.push(v.option1);
      if (v.option2 != null && v.option2 !== '') out.push(v.option2);
      if (v.option3 != null && v.option3 !== '') out.push(v.option3);
      return out;
    }

    function findVariant() {
      var byId = null;
      if (variantInput && variantInput.value) {
        var vid = parseInt(variantInput.value, 10);
        if (!isNaN(vid)) {
          byId = product.variants.find(function (vv) { return vv.id === vid; });
        }
      }
      if (!optionSelects.length) return byId || product.variants[0];
      var selected = optionSelects.map(function (s) { return s.value; });
      var matched = product.variants.find(function (v) {
        var opts = variantOptionValues(v);
        if (opts.length !== selected.length) return false;
        return selected.every(function (val, i) { return val === opts[i]; });
      });
      return matched || byId || product.variants[0];
    }

    function getPpsFromVariant(v) {
      /* use config cents first, then live variant price */
      if (pricePerSqftCents > 0) return pricePerSqftCents;
      return (v && v.price) ? v.price : 0;
    }

    function onVariantChange() {
      var v = findVariant();
      if (!v || !variantInput) { updateLineEstimate(); return; }
      variantInput.value = v.id;
      var pps = getPpsFromVariant(v);
      if (priceEl) priceEl.textContent = formatMoney(pps);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.style.display = '';
          compareEl.textContent = formatMoney(v.compare_at_price);
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (v.featured_image && mainImg && v.featured_image.src) {
        var u = v.featured_image.src.split('?')[0];
        mainImg.src = u + '?width=1600';
      }
      updateLineEstimate();
      updateOrderCta();
    }

    function updateLineEstimate() {
      if (!subWrap) {
        updateShippingNotes(getTotalSqft());
        updateOrderCta();
        return;
      }
      var v = findVariant();
      var totalSqft = getTotalSqft();
      if (subSqftLabel) subSqftLabel.textContent = String(totalSqft);
      var pps = getPpsFromVariant(v);
      if (subRateLabel) {
        subRateLabel.textContent = pps > 0 ? formatMoney(pps) + ' / sq ft' : '';
      }
      if (!v || totalSqft < 1) {
        subWrap.hidden = true;
        updateShippingNotes(0);
        updateOrderCta();
        return;
      }
      subWrap.hidden = false;
      /* total = sq ft × price per sq ft (only when price is shown on page) */
      if (subMoney) subMoney.textContent = formatMoney(totalSqft * pps);
      updateShippingNotes(totalSqft);
      updateOrderCta();
    }

    function updateShippingNotes(totalSqft) {
      var fulfillment = getSelectedFulfillment();
      var isResidential = fulfillment === 'ship-residential';
      var isCommercial = fulfillment === 'ship-commercial';
      var isPickup = fulfillment === 'pickup';
      var under500 = totalSqft > 0 && totalSqft < SHIPPING_THRESHOLD_SQFT;
      var qualifiesFree = isCommercial && totalSqft >= SHIPPING_THRESHOLD_SQFT;

      if (shippingResidentialNote) shippingResidentialNote.hidden = !isResidential;
      if (shippingUnder500Note) {
        shippingUnder500Note.hidden = !((isCommercial || isPickup) && under500);
      }
      if (shippingQuoteNote) shippingQuoteNote.hidden = true;
      if (shippingFreeNote) shippingFreeNote.hidden = !qualifiesFree;
    }

    function recalc() {
      var raw = sqftInput ? parseFloat(sqftInput.value) : NaN;
      if (!sqftInput || isNaN(raw) || raw <= 0) {
        if (cartonsOut)  cartonsOut.textContent  = '0';
        if (cartonQtyDisplay) cartonQtyDisplay.value = '1';
        if (recommendWrap) recommendWrap.hidden = true;
        if (totalSqftOut) totalSqftOut.textContent = '0';
        if (qtyHidden)   qtyHidden.value  = '1';
        if (propSqft)    propSqft.value   = '';
        if (propOver)    propOver.value   = '';
        if (propCartons) propCartons.value = '';
        if (propCartonsCount) propCartonsCount.value = '';
        updateLineEstimate();
        return;
      }
      var factor = overageChk && overageChk.checked ? 1.05 : 1;
      var need   = raw * factor;

      /* Always round UP to the next full carton */
      var cartons = sqftPer > 0 ? Math.ceil(need / sqftPer) : 0;
      if (sqftPer > 0 && cartons < 1) cartons = 1;
      var totalSqft = sqftPer > 0 ? Math.round(cartons * sqftPer * 1000) / 1000 : Math.ceil(need);

      if (cartonsOut)   cartonsOut.textContent   = cartons > 0 ? String(cartons) : '—';
      if (cartonQtyDisplay) cartonQtyDisplay.value = cartons > 0 ? String(cartons) : '1';
      if (recommendWrap) recommendWrap.hidden = !(cartons > 0);
      if (recommendCartons) recommendCartons.textContent = cartons > 0 ? String(cartons) : '1';
      if (recommendSqft) recommendSqft.textContent = String(totalSqft);
      if (totalSqftOut) totalSqftOut.textContent = String(totalSqft);
      if (qtyHidden)    qtyHidden.value  = String(Math.max(1, Math.round(totalSqft)));
      if (propSqft)     propSqft.value   = String(Math.round(raw * 1000) / 1000);
      if (propOver)     propOver.value   = overageChk && overageChk.checked ? 'Yes' : 'No';
      if (propCartons && cartons > 0)
        propCartons.value = String(cartons) + ' carton(s)' + (sqftPer > 0 ? ' · ' + sqftPer + ' sq ft each' : '');
      if (propCartonsCount)
        propCartonsCount.value = cartons > 0 ? String(cartons) : '';
      updateLineEstimate();
    }

    /* Always snap the entered sq ft UP to the next full carton. Overage (if
       checked) is applied afterward in recalc() when counting cartons. */
    function snapToCartons() {
      if (!sqftInput) return;
      var raw = parseFloat(sqftInput.value);
      if (isNaN(raw) || raw <= 0 || !(sqftPer > 0)) {
        recalc();
        return;
      }
      var snapped = Math.round(Math.ceil(raw / sqftPer) * sqftPer * 1000) / 1000;
      if (snapped > 0) {
        sqftInput.value = String(snapped);
      }
      recalc();
    }

    optionSelects.forEach(function (sel) {
      sel.addEventListener('change', onVariantChange);
    });

    var addBtnInit = qs(root, '[data-bff-add]');
    if (addBtnInit) {
      if (!addBtnInit.getAttribute('data-label-available'))
        addBtnInit.setAttribute('data-label-available', addBtnInit.textContent.trim());
      if (!addBtnInit.getAttribute('data-label-sold'))
        addBtnInit.setAttribute('data-label-sold', 'Sold out');
    }

    qsa(root, '[data-bff-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.getAttribute('data-full-src');
        if (src && mainImg) mainImg.src = src;
        qsa(root, '[data-bff-thumb]').forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
      });
    });

    if (sqftInput) {
      sqftInput.addEventListener('input', recalc);
      sqftInput.addEventListener('change', snapToCartons);
      sqftInput.addEventListener('blur', snapToCartons);
    }
    if (overageChk) overageChk.addEventListener('change', recalc);
    fulfillmentInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        updateShippingNotes(getTotalSqft());
        updateOrderCta();
      });
    });

    var form = qs(root, '#BffProductForm') || qs(root, 'form.bff-product__form');
    if (form) {
      form.addEventListener('submit', function (e) {
        if (!canOrderOnline()) {
          e.preventDefault();
          updateOrderCta();
          if (callQuoteCta) callQuoteCta.focus();
        }
      });
    }

    recalc();
    onVariantChange();
    updateOrderCta();
  }

  function initTabs() {
    var tabs = qsa(document, '[data-bff-tab]');
    if (!tabs.length) return;
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var id = tab.getAttribute('data-bff-tab');
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-bff-tab') === id;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        qsa(document, '[data-bff-panel]').forEach(function (p) {
          var on = p.getAttribute('data-bff-panel') === id;
          p.classList.toggle('is-active', on);
          p.hidden = !on;
        });
      });
    });
  }

  function initFacets() {
    var toggle = qs(document, '[data-bff-facets-toggle]');
    var panel  = qs(document, '[data-bff-facets-panel]');
    if (!toggle || !panel) return;
    toggle.addEventListener('click', function () {
      var open = !panel.hidden;
      panel.hidden = open;
      toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
  }

  function initSampleButtons() {
    var SC = window.BffSamplesCart;
    var buttons = qsa(document, '[data-bff-sample-add-btn]');
    if (!buttons.length || !SC) return;

    var checkoutUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
      ? window.Shopify.routes.root + 'checkout'
      : '/checkout';

    function goCheckout() {
      window.location.href = checkoutUrl;
    }

    function showFeedback(box, html, isError) {
      var feedback = box ? qs(box, '[data-bff-sample-feedback]') : null;
      if (!feedback) return;
      feedback.innerHTML = html;
      feedback.hidden = false;
      feedback.className = 'bff-product__sample-feedback' + (isError ? ' bff-product__sample-feedback--error' : ' bff-product__sample-feedback--ok');
    }

    function setButtonInCart(btn, inCart) {
      if (inCart) {
        btn.classList.add('is-in-cart');
      }
    }

    buttons.forEach(function (btn) {
      var box = btn.closest('[data-bff-sample-box]');
      var variantId = btn.getAttribute('data-sample-variant-id');
      var sampleProductHandle = btn.getAttribute('data-sample-product-handle') || 'sample';
      var parentHandle = btn.getAttribute('data-parent-handle') || '';
      var productName = btn.getAttribute('data-sample-product') || '';
      var productSku = btn.getAttribute('data-sample-sku') || '';
      var label = SC.formatLabel(productName, productSku);
      var defaultLabel = btn.getAttribute('data-default-label') || btn.textContent;

      btn.setAttribute('data-default-label', defaultLabel);

      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (SC.cartHasSampleForProduct(cart, parentHandle, sampleProductHandle)) {
            setButtonInCart(btn, true);
          }
        })
        .catch(function () {});

      btn.addEventListener('click', function () {
        if (btn.classList.contains('is-in-cart')) {
          goCheckout();
          return;
        }

        if (!variantId) {
          showFeedback(box, 'Sample product not set up yet. Create a product with handle <strong>sample</strong> priced at $25.', true);
          return;
        }

        btn.disabled = true;
        SC.addStyleToCart(variantId, sampleProductHandle, label, parentHandle)
          .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
          .then(function (cart) {
            var countEl = document.querySelector('[data-bff-header-cart-count]');
            if (countEl) countEl.textContent = String(cart.item_count);
            goCheckout();
          })
          .catch(function (err) {
            btn.disabled = false;
            if (err.message === 'max_samples') {
              showFeedback(box, 'Your sample order already has 5 styles (the maximum). <a href="' + checkoutUrl + '">Go to checkout</a>.', true);
            } else if (err.message === 'duplicate') {
              setButtonInCart(btn, true);
              goCheckout();
            } else {
              showFeedback(box, 'Could not add sample. Please try again.', true);
            }
          });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initProduct(qs(document, '[data-bff-product]'));
    initTabs();
    initFacets();
    initSampleButtons();
  });
})();
